/**
 * WURFL module
 * @author Tim Sullivan
 *
 */
define([], function () {
	'use strict';

	var isWireless = document.body.getAttribute('data-iswireless') === 'true',
		isTablet = document.body.getAttribute('data-istablet') === 'true',
		isSmartphone = isWireless && !isTablet;

	return {
		isWireless: isWireless,
		isTablet: isTablet,
		isSmartphone: isSmartphone
	};
});



//////////////////
// WEBPACK FOOTER
// ./lib/wurfl.js
// module id = 24
// module chunks = 0